import { useEffect, useState } from 'react'
import { ActionButton, CloseButton, EcheckDetails, EcheckHeader, EcheckInfo, EcheckItem, EcheckList, EcheckMeta, EcheckValue, EmptyIcon, EmptyState, MetaItem, ModalBody, ModalContainer, ModalHeader, ModalOverlay, ModalTitle, ReceiverName, SearchContainer, SearchInput, StatusBadge } from './style';
import moment from 'moment';
import { apiV1 } from '../../../../lib/axios';
import { toast } from 'react-toastify';
import {Pagination} from 'antd'

const EcheckListModal = ({ isOpen, onClose, echecks, countEchecks, fetchEcheck }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
    startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  });
  const [statusFilter, setStatusFilter] = useState('');

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  const fetchEchecksByPage = (page) => {
    setPagination({ ...pagination, page });
    let payload = {
      page,
      search: searchQuery,
      status: statusFilter,
    }

    if (pagination.startDate) payload.initialDate = pagination.startDate;
    if (pagination.endDate) payload.finalDate = pagination.endDate;
    fetchEcheck(payload);
  };

  const getStatusDisplay = (status) => {
    const statusMap = {
      Created: 'Pendente',
      Paid: 'Pago',
      Canceled: 'Cancelado',
    };

    return statusMap[status] || status;
  }

  const handleViewDetails = (echeck) => {
    if(loader) return;

    if(echeck.status == 'Paid') fetchVoucher(echeck.documentNumber);
    if(echeck.status == 'Created') resendEcheck(echeck);
  };

  const fetchVoucher = async (documentNumber) => {
    setLoader(true);
    try {
      const response = await apiV1.post('/voucher/fetch', {
        type: 'ECHECK',
        documentNumber,
      });
      const url = response.data.url;
      window.open(url, '_blank');
    } catch (error) {
      console.error('Erro ao criar o comprovante:', error);
      throw error;
    } finally {
      setLoader(false);
    }
  };
    
  const resendEcheck = async (echeck) => {
    try{
      setLoader(true);
      await apiV1.post('/echeque/resend', {
        echeckId: echeck.id,
        clientId: echeck.clientId,
      });
      toast.success('e-Check reenviado com sucesso!');
    } catch (error) {
      console.error('Erro ao reenviar o e-Check:', error);
      throw error;
    } finally {
      setLoader(false);
    }
  }

  useEffect(() => {
    if (searchQuery.length > 0) {
      fetchEcheck({
        page: pagination.page,
        initialDate: pagination.startDate,
        finalDate: pagination.endDate,
        search: searchQuery,
        status: statusFilter
      });
    }
  }, [searchQuery]);

  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>e-Checks Emitidos</ModalTitle>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>
        
        <ModalBody>
          <SearchContainer>
            <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'end' }}>
              <div style={{ flex: '1 1 200px' }}>
                <label style={{ display: 'block', fontSize: '.9rem', marginBottom: '.25rem' }}>
                  Data inicial
                </label>
                <SearchInput
                  type="date"
                  value={pagination.startDate}
                  onChange={(e) => setPagination({ ...pagination, startDate: e.target.value })}
                />
              </div>

              <div style={{ flex: '1 1 200px' }}>
                <label style={{ display: 'block', fontSize: '.9rem', marginBottom: '.25rem' }}>
                  Data final
                </label>
                <SearchInput
                  type="date"
                  value={pagination.endDate}
                  onChange={(e) => setPagination({ ...pagination, endDate: e.target.value })}
                />
              </div>
            </div>

             <div style={{ marginTop: '1.5rem' }}>
              <label style={{ display: 'block', fontSize: '.9rem', marginBottom: '.5rem' }}>
                Filtrar por status
              </label>
              <div style={{ display: 'flex', gap: '.5rem', flexWrap: 'wrap' }}>
                <button
                  onClick={() => setStatusFilter('')}
                  style={{
                    padding: '.5rem 1rem',
                    border: statusFilter === '' ? '2px solid var(--primary-color)' : '1px solid #ccc',
                    borderRadius: '20px',
                    background: statusFilter === '' ? 'var(--primary-color)' : 'white',
                    color: statusFilter === '' ? 'white' : '#333',
                    cursor: 'pointer',
                    fontSize: '.9rem',
                    fontWeight: statusFilter === '' ? '600' : '400',
                    transition: 'all 0.2s'
                  }}
                >
                  Todos
                </button>
                <button
                  onClick={() => setStatusFilter('Paid')}
                  style={{
                    padding: '.5rem 1rem',
                    border: statusFilter === 'Paid' ? '2px solid #00a86b' : '1px solid #ccc',
                    borderRadius: '20px',
                    background: statusFilter === 'Paid' ? '#00a86b' : 'white',
                    color: statusFilter === 'Paid' ? 'white' : '#333',
                    cursor: 'pointer',
                    fontSize: '.9rem',
                    fontWeight: statusFilter === 'Paid' ? '600' : '400',
                    transition: 'all 0.2s'
                  }}
                >
                  Pago
                </button>
                <button
                  onClick={() => setStatusFilter('Created')}
                  style={{
                    padding: '.5rem 1rem',
                    border: statusFilter === 'Created' ? '2px solid #ffc107' : '1px solid #ccc',
                    borderRadius: '20px',
                    background: statusFilter === 'Created' ? '#ffc107' : 'white',
                    color: statusFilter === 'Created' ? 'white' : '#333',
                    cursor: 'pointer',
                    fontSize: '.9rem',
                    fontWeight: statusFilter === 'Created' ? '600' : '400',
                    transition: 'all 0.2s'
                  }}
                >
                  Pendente
                </button>
                <button
                  onClick={() => setStatusFilter('Canceled')}
                  style={{
                    padding: '.5rem 1rem',
                    border: statusFilter === 'Canceled' ? '2px solid #dc3545' : '1px solid #ccc',
                    borderRadius: '20px',
                    background: statusFilter === 'Canceled' ? '#dc3545' : 'white',
                    color: statusFilter === 'Canceled' ? 'white' : '#333',
                    cursor: 'pointer',
                    fontSize: '.9rem',
                    fontWeight: statusFilter === 'Canceled' ? '600' : '400',
                    transition: 'all 0.2s'
                  }}
                >
                  Cancelado
                </button>

                <ActionButton
                  onClick={() => fetchEchecksByPage(1)}
                >
                  Filtrar
                </ActionButton>
              </div>
            </div>

            <SearchInput
              type="text"
              placeholder="Pesquisar por nome, chave pix ou status..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ marginTop: '1rem' }}
            />
          </SearchContainer>

          {!echecks || echecks.length === 0 ? (
            <EmptyState>
              <EmptyIcon>📄</EmptyIcon>
              <h3>Nenhum e-Check encontrado</h3>
              <p>Tente ajustar sua pesquisa ou verifique se há e-Checks cadastrados.</p>
            </EmptyState>
          ) : (
            <>
              <Pagination
                onChange={(e) => fetchEchecksByPage(e)}
                style={{ marginTop: '2.5rem', marginBottom: '1rem', justifyContent: 'center', display: 'flex' }}
                pageSize={20}
                showSizeChanger={false}
                defaultCurrent={1}
                total={countEchecks}
                current={pagination.page}
              />
              <EcheckList>
                {echecks?.map((echeck) => (
                  <EcheckItem key={echeck?.id}>
                    <EcheckHeader>
                      <EcheckInfo>
                        <ReceiverName>{echeck?.client?.name}</ReceiverName>
                        <EcheckDetails>
                          • Criado em {moment(echeck?.createdAt).format('DD/MM/YYYY')}
                        </EcheckDetails>
                      </EcheckInfo>
                      <div className="d-flex align-items-center">
                        <EcheckValue>
                          {formatCurrency(echeck?.value)}
                        </EcheckValue>
                        <StatusBadge className={echeck?.status?.toLowerCase()}>
                          {getStatusDisplay(echeck?.status)}
                        </StatusBadge>
                        {
                          echeck?.status?.toLowerCase() !== 'canceled' && (
                            <ActionButton onClick={() => handleViewDetails(echeck)}>
                              { loader && 'Carregando...' }
                              { (echeck?.status?.toLowerCase() === 'created' && !loader) && 'Reenviar e-Check' }
                              { (echeck?.status?.toLowerCase() === 'paid' && !loader) && 'Ver Comprovante' }
                            </ActionButton>
                          )
                        }
                      </div>
                    </EcheckHeader>
                    
                    <EcheckMeta>
                      <MetaItem>
                        <strong>Chave PIX:</strong><br />
                        {echeck.pixKey}
                      </MetaItem>
                      <MetaItem>
                        <strong>Descrição:</strong><br />
                        {echeck.description || 'Sem descrição'}
                      </MetaItem>
                    </EcheckMeta>
                  </EcheckItem>
                ))}
              </EcheckList>
            </>
          )}
        </ModalBody>
      </ModalContainer>
    </ModalOverlay>
  );
}

export default EcheckListModal
